import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=b8a9d6cc&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8a9d6cc')) {
      api.createRecord('b8a9d6cc', component.options)
    } else {
      api.reload('b8a9d6cc', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=b8a9d6cc&", function () {
      api.rerender('b8a9d6cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8qFO9M8xZMEj8/JS/comp/ErrorMessage.vue"
export default component.exports